import request from 'superagent';

const url = '/api/auth/password/reset';

export function resetPasswordRequest(email) {
  return new Promise((resolve, reject) => {
    request.post(url)
      .set('Content-Type', 'application/json')
      .send({email})
      .end((err, res) => {
        if (!err && res.statusCode === 204) {
          return resolve();
        }

        return reject(err);
      });
  });
}

export function isResetRequestValid(token) {
  return new Promise((resolve, reject) => {
    request.get(url)
      .query({token})
      .end((err, res) => {
        if (!err && res.statusCode === 204) {
          return resolve();
        }

        return reject(err);
      });
  });
}

export function updatePassword(token, password) {
  return new Promise((resolve, reject) => {
    request.put(url)
      .set('Content-Type', 'application/json')
      .send({token, password})
      .end((err, res) => {
        if (!err && res.statusCode === 204) {
          return resolve();
        }

        return reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./shared/redux/api/auth.js